import { app } from '../../../../app';

app.factory('ApplicationUsageReportService', ApplicationUsageReportService);

/** @ngInject */
function ApplicationUsageReportService($resource) {
    var rootUrl = 'app/rest/company/:companyId/report';
    
    return {
        usageReport :  $resource(rootUrl,{},
                { 
        	'getCompanyApplications' : {
            method : 'GET',
            url: rootUrl+'/appusage',
            isArray : true,
            params : {
                companyId : '@companyId'
            }
            },
            'getFilterByTypeIdApplications' : {
            method : 'GET',
            url: rootUrl+'/appusagecustom',
            isArray : true,
            params : {
                companyId : '@companyId',
                appTypeId: 	'@appTypeId'
            }
            }
        }),

    }
    
}


// WEBPACK FOOTER //
// ./src/portal/states/company/reports/application-usage-report/application-usage-report.service.js